import {Injectable} from '@angular/core';

import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import {MenuCategoryService} from '../_services/menu-category.service';

@Injectable()
export class MenuCategoryListResolver implements Resolve<any> {
    constructor(private menuCategoryService: MenuCategoryService) {
    }

    resolve(route: ActivatedRouteSnapshot) {
        return this.menuCategoryService.findByOrgId(route.paramMap.get('orgId'));
    }
}
